
<div class="text-area-input" :class="{ disabled }">
  <label :for="id">{{ label }}</label>

  <textarea-autosize
    ref="input"
    v-model="localValue"
    :min-height="minheight"
    :id="id"
    :name="id"
    :maxlength="maxlength"
    :required="required"
    :disabled="disabled"
    @input="update"
  />
</div>
